var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configuration-buildings-container" },
    [
      _c("v-card", { staticClass: "stepperCard" }, [
        _c(
          "div",
          { staticClass: "scrollStep" },
          [
            _c("span", { staticClass: "stepperTitle" }, [
              _vm._v("Create Configuration")
            ]),
            _vm._v(" "),
            _c("Stepper", {
              attrs: { steps: _vm.data, currentStep: _vm.currentStep },
              on: { onStepClick: _vm.onStepClick }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("v-card", { staticClass: "formCard" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepData[0][_vm.currentStep].type === "form",
                expression: "stepData[0][currentStep].type === 'form'"
              }
            ],
            staticClass: "form tab-content inputNPV"
          },
          _vm._l(_vm.stepData[0][_vm.currentStep].fields, function(field) {
            return _c("InputFieldNPV", {
              key: field.label + field.order,
              ref: "formInputField",
              refInFor: true,
              attrs: {
                value: _vm.getValueInObject(field.var_name, field.input_type),
                label: field.label_client ? field.label_client : field.label,
                "variable-name": field.var_name,
                inputType: field.input_type,
                size: field.size,
                required: field.required,
                selectOptions: field.select_list_name,
                radioOptions: field.radio_options,
                hide: field.hide,
                "automatic-label": field.has_automatic_label,
                checkboxOptions: field.checkbox_options
              },
              on: {
                input: function($event) {
                  return _vm.setValueInObject(
                    field.var_name,
                    $event,
                    field.input_type
                  )
                },
                updateCheckboxValue: function($event) {
                  return _vm.updateCheckboxValue($event)
                },
                removePhoto: function($event) {
                  return _vm.addToPhotosToRemove($event)
                }
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.stepData[0][_vm.currentStep].type === "other" &&
                  _vm.stepData[0][_vm.currentStep].code ===
                    "simulation_configuration_street_types",
                expression:
                  "\n        stepData[0][currentStep].type === 'other' &&\n        stepData[0][currentStep].code ===\n          'simulation_configuration_street_types'\n      "
              }
            ],
            staticClass: "form tab-content inputNPVTable"
          },
          [
            _c(
              "div",
              { staticClass: "addButtonDiv" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "addButtonNPV",
                    attrs: { color: "#67a0b4" },
                    on: {
                      click: function($event) {
                        return _vm.addRowTable("street_types")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(" add ")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              attrs: {
                headers: _vm.headerStreets,
                items:
                  _vm.stepData[0][_vm.currentStep].fields.length > 0
                    ? _vm.stepData[0][_vm.currentStep].fields
                    : _vm.dataStreets,
                "items-per-page": 10
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value: _vm.dataStreets[props.index].street_type_id
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "street_type_id",
                                  "street_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataStreets[props.index].geo2trail,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "geo2trail",
                                    "street_types",
                                    "checkbox"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value: _vm.dataStreets[props.index].width_meter
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "width_meter",
                                  "street_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataStreets[props.index].is_private,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "is_private",
                                    "street_types",
                                    "checkbox"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataStreets[props.index]
                                    .disable_secondary_side,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "disable_secondary_side",
                                    "street_types",
                                    "checkbox"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.dataStreets[props.index].side_cost_meter
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "side_cost_meter",
                                  "street_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.dataStreets[props.index].crossing_cost_meter
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "crossing_cost_meter",
                                  "street_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataStreets[props.index].permit_crossing,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "permit_crossing",
                                    "street_types",
                                    "checkbox"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.dataStreets[props.index]
                                  .opt_cost_multiplier_crossing
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "opt_cost_multiplier_crossing",
                                  "street_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("input", {
                              staticClass: "no-border",
                              staticStyle: { width: "80%" },
                              attrs: { type: "number" },
                              domProps: {
                                value:
                                  _vm.dataStreets[props.index]
                                    .urban_cost_multiplier
                              },
                              on: {
                                input: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event.target.value,
                                    props.index,
                                    "urban_cost_multiplier",
                                    "street_types",
                                    "number"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "8px" } },
                              [
                                _c("app-datatable-action-buttons", {
                                  attrs: {
                                    "user-can-delete": _vm.isSuperAdmin
                                  },
                                  on: {
                                    delete: function($event) {
                                      return _vm.deleteItem(
                                        props.index,
                                        "street_types"
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.stepData[0][_vm.currentStep].type === "other" &&
                  _vm.stepData[0][_vm.currentStep].code ===
                    "simulation_configuration_surface_types",
                expression:
                  "\n        stepData[0][currentStep].type === 'other' &&\n        stepData[0][currentStep].code ===\n          'simulation_configuration_surface_types'\n      "
              }
            ],
            staticClass: "form tab-content inputNPVTable"
          },
          [
            _c(
              "div",
              { staticClass: "addButtonDiv" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "addButtonNPV",
                    attrs: { color: "#67a0b4" },
                    on: {
                      click: function($event) {
                        return _vm.addRowTable("surface_types")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(" add ")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              attrs: {
                headers: _vm.headerSurface,
                items:
                  _vm.stepData[0][_vm.currentStep].fields.length > 0
                    ? _vm.stepData[0][_vm.currentStep].fields
                    : _vm.dataSurface,
                "items-per-page": 10
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value:
                                _vm.dataSurface[props.index].surface_type_id
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "surface_type_id",
                                  "surface_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("input", {
                              staticClass: "no-border",
                              attrs: { type: "number" },
                              domProps: {
                                value: _vm.dataSurface[props.index].cost_meter
                              },
                              on: {
                                input: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event.target.value,
                                    props.index,
                                    "cost_meter",
                                    "surface_types",
                                    "number"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("app-datatable-action-buttons", {
                              attrs: { "user-can-delete": _vm.isSuperAdmin },
                              on: {
                                delete: function($event) {
                                  return _vm.deleteItem(
                                    props.index,
                                    "surface_types"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.stepData[0][_vm.currentStep].type === "other" &&
                  _vm.stepData[0][_vm.currentStep].code ===
                    "simulation_configuration_railway_types",
                expression:
                  "\n        stepData[0][currentStep].type === 'other' &&\n        stepData[0][currentStep].code ===\n          'simulation_configuration_railway_types'\n      "
              }
            ],
            staticClass: "form tab-content inputNPVTable"
          },
          [
            _c(
              "div",
              { staticClass: "addButtonDiv" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "addButtonNPV",
                    attrs: { color: "#67a0b4" },
                    on: {
                      click: function($event) {
                        return _vm.addRowTable("railway_types")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(" add ")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              attrs: {
                headers: _vm.headerRailway,
                items:
                  _vm.stepData[0][_vm.currentStep].fields.length > 0
                    ? _vm.stepData[0][_vm.currentStep].fields
                    : _vm.dataRailway,
                "items-per-page": 10
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.dataRailway[props.index].name
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "name",
                                  "railway_types"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "number" },
                            domProps: {
                              value: _vm.dataRailway[props.index].crossing_cost
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "crossing_cost",
                                  "railway_types",
                                  "number"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataRailway[props.index].geo2trail,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "geo2trail",
                                    "railway_types",
                                    "checkbox"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("app-datatable-action-buttons", {
                              attrs: { "user-can-delete": _vm.isSuperAdmin },
                              on: {
                                delete: function($event) {
                                  return _vm.deleteItem(
                                    props.index,
                                    "railway_types"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.stepData[0][_vm.currentStep].type === "other" &&
                  _vm.stepData[0][_vm.currentStep].code ===
                    "simulation_configuration_waterway_types",
                expression:
                  "\n        stepData[0][currentStep].type === 'other' &&\n        stepData[0][currentStep].code ===\n          'simulation_configuration_waterway_types'\n      "
              }
            ],
            staticClass: "form tab-content inputNPVTable"
          },
          [
            _c(
              "div",
              { staticClass: "addButtonDiv" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "addButtonNPV",
                    attrs: { color: "#67a0b4" },
                    on: {
                      click: function($event) {
                        return _vm.addRowTable("waterway_types")
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v(" add ")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-data-table", {
              attrs: {
                headers: _vm.headerWaterway,
                items:
                  _vm.stepData[0][_vm.currentStep].fields.length > 0
                    ? _vm.stepData[0][_vm.currentStep].fields
                    : _vm.dataWaterway,
                "items-per-page": 10
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(props) {
                    return [
                      _c("tr", [
                        _c("td", [
                          _c("input", {
                            staticClass: "no-border",
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.dataWaterway[props.index].name
                            },
                            on: {
                              input: function($event) {
                                return _vm.valueTableUpdate(
                                  $event.target.value,
                                  props.index,
                                  "name",
                                  "waterway_types"
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("v-checkbox", {
                              attrs: {
                                color: "accent",
                                "input-value":
                                  _vm.dataWaterway[props.index].geo2trail,
                                label: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.valueTableUpdate(
                                    $event,
                                    props.index,
                                    "geo2trail",
                                    "waterway_types",
                                    "checkbox"
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("app-datatable-action-buttons", {
                              attrs: { "user-can-delete": _vm.isSuperAdmin },
                              on: {
                                delete: function($event) {
                                  return _vm.deleteItem(
                                    props.index,
                                    "waterway_types"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-618f2004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618f2004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Npv/Configuration/views/ConfigurationForms.vue
// module id = null
// module chunks = 